module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.thead {\r\n    background: #808080;\r\n    color: #fff;\r\n}\r\n\r\ntable{\r\n    border: 1px solid #444;\r\n    \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/rate-fixation/rate-fixation-form/rate-fixation-form.component.css
// module id = ./src/app/recovery/rate-fixation/rate-fixation-form/rate-fixation-form.component.css
// module chunks = main